import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Headroom from 'react-headroom';
import Menu from './menu';
import { Link } from 'gatsby';
import logoSmallSvg from "../../images/logos/pcc-icon.svg"
import logoSmallSvgWhite from "../../images/logos/pcc-icon-white.svg"
import logoSvg from "../../images/logos/pcc-logo.svg"
import logoSvgWhite from "../../images/logos/pcc-logo-white.svg"
import {transparentAtTop,atTop,menuOpen,headerMain,headerInner,leftWrapper,logo,linksList,calculatorsLink,link,active,rightWrapper,headerCtaBtn,menuBtn,menuIcon,closeIcon, growOnHover,banner,dropdownWrapper,dropdown,dropdownItem} from './header.module.scss';

import useIsDesktopSize from '../../utils/isDesktopHook';
import { isDecember, isJanuary } from '../../utils/helpers';
import NewYearCountdown from '../new-year-countdown'
import NewYearCountdownDays from '../new-year-countdown-days'
import { countdown } from './header.module.scss';
import { FaArrowRight } from 'react-icons/fa';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';

const HeaderMain = ({ siteTitle = ``, pathname = `` }) => {
    const isDesktopSize = useIsDesktopSize();
    const isHome = pathname === '/';
    const showSubheader = isHome;
    const isTransparentAtTop = false;
    const [isAtTop, setIsAtTop] = useState(true);
    const [isMenuOpen, toggleMenu] = useState(false);
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const isDec = isDecember();
    const isJan = isJanuary();
    const showBannerPromo = !isHome && (isDec || isJan);
    const showCountdownPromo = isDec;

    const toggleMobileMenu = () => toggleMenu(!isMenuOpen);
    const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);

    const wrapperClassList = [
        `header-main-wrapper`,
        isTransparentAtTop ? `${transparentAtTop}` : ``,
        isAtTop ? atTop : ``,
        isMenuOpen ? menuOpen : ``,
    ];

    const CalculatorDropdown = () => {
        return (
            <div className={dropdown}>
                <Link to="/calculator/salary" className={dropdownItem}>Salary Calculator</Link>
                <Link to="/calculator/hourly" className={dropdownItem}>Hourly Calculator</Link>
                <Link to="/calculator/flatbonus" className={dropdownItem}>Bonus Tax Percent Calculator</Link>
                <Link to="/calculator/agbonus" className={dropdownItem}>Bonus Tax Aggregate Calculator</Link>
                <Link to="/calculator/grossup" className={dropdownItem}>Gross-Up Calculator</Link>
                <Link to="/calculator/dualhourly" className={dropdownItem}>Dual Scenario Hourly Calculator</Link>
                <Link to="/calculator/dualsalary" className={dropdownItem}>Dual Scenario Salary Calculator</Link>
                <Link to="/calculator/401k" className={dropdownItem}>401k Calculator</Link>
                <Link to="/calculator/taxtip" className={dropdownItem}>Tax Tip Calculator</Link>
                <Link to="/calculator/children" className={dropdownItem}>Children Calculator</Link>
                <Link to="/calculator/divorce" className={dropdownItem}>Divorce Calculator</Link>
                <Link to="/calculator/marriage" className={dropdownItem}>Marriage Calculator</Link>
            </div>
        );
    };

    return (
        <header role="banner" itemScope itemType="http://schema.org/WPHeader">
            {showBannerPromo && (
                <Link to="/" id="countdown-banner" className={`${banner} icon-animate-bounce`}>
                    {
                        showCountdownPromo && (
                            <>
                                {isDesktopSize ? (
                                    <span className={`${countdown}`}> <NewYearCountdown size="small" /></span>
                                ) : <NewYearCountdownDays />}
                                <span>
                                    &nbsp;until Jan 1.&nbsp;
                                </span>
                            </>
                        ) 
                    }
                    <strong className="btn-text-white underline-partial">
                        Now is the easiest time to switch your payroll service.&nbsp;
                        <span className="underline-target">Try PaycheckCity Payroll for free!</span>
                        <span className="align-icon"><FaArrowRight /></span>
                    </strong>
                </Link>)
            }
            <Headroom
                className={ wrapperClassList.join(' ') }
                onUnpin={ () => {
                    if(isTransparentAtTop) {
                        setIsAtTop(false);
                    }
                } }
                onUnfix={ () => {
                    if(isTransparentAtTop && !isMenuOpen) {
                        setIsAtTop(true);
                    }
                } }
                disableInlineStyles={ isMenuOpen }>
                <nav className={ `${headerMain}` } role="navigation" itemType="https://schema.org/SiteNavigationElement">
                    <div className={ `skip-to-main-wrapper` }>
                        <a
                            className={ `btn skip-to-main` }
                            href="#main-content">
                            Skip to main content
                        </a>
                    </div>
                    <div className={ `${headerInner}` }>
                        <div className={ leftWrapper }>
                            <Link
                                to="/"
                                className={ `${logo} ${growOnHover}`}>
                                <span className="sr-only" itemProp="name">
                                    { siteTitle }
                                </span>
                                { isTransparentAtTop && isAtTop && !isMenuOpen ? (
                                    <div className="flex">
                                        <div className={ showSubheader ? `hidden` : `hide-on-xl flex-shrink-0` }>
                                            <img
                                                src={ logoSmallSvgWhite }
                                                alt={ siteTitle }
                                                title={ siteTitle }
                                                aria-hidden="true"
                                                itemProp="logo"
                                            />
                                        </div>
                                        <div className={ showSubheader ? `flex` : `show-on-xl` }>
                                            <img
                                                src={ logoSvgWhite }
                                                alt={ siteTitle }
                                                title={ siteTitle }
                                                aria-hidden="true"
                                                itemProp="logo"
                                            />
                                        </div>
                                    </div>
                                    ) : (
                                    <div className="flex">
                                        <div className={ showSubheader ? `hide-on-md` : `hide-on-xl flex-shrink-0` }>
                                            <img
                                                src={ logoSmallSvg }
                                                alt={ siteTitle }
                                                title={ siteTitle }
                                                aria-hidden="true"
                                                itemProp="logo"
                                            />
                                        </div>
                                        <div className={ showSubheader ? `show-on-md` : `show-on-xl` }>
                                            <img
                                                src={ logoSvg }
                                                alt={ siteTitle }
                                                title={ siteTitle }
                                                aria-hidden="true"
                                                itemProp="logo"
                                            />
                                        </div>
                                    </div>
                                )}
                            </Link>
                            <div className={ linksList }>
                            <div className={dropdownWrapper} onMouseEnter={toggleDropdown} onMouseLeave={toggleDropdown}>
                                    <Link
                                        to="/calculator"
                                        className={ `${calculatorsLink} ${link}` }
                                        activeClassName={ `${active}` }
                                        partiallyActive={ true }>
                                        <span className={ 'show-on-sm' }>Free&nbsp;</span>Paycheck Calculators
                                        {isDropdownOpen ? <MdArrowDropUp /> : <MdArrowDropDown />}
                                    </Link>
                                    {isDropdownOpen && <CalculatorDropdown />}
                                </div>
                                <Link
                                    to="/payroll-resources"
                                    className={ `show-on-sm ${link}` }
                                    activeClassName={ `${active}` }
                                    partiallyActive={ true }>
                                    Payroll Resources
                                </Link>
                                <Link
                                    to="/small-business-guide"
                                    className={ `show-on-lg ${link}` }
                                    activeClassName={ `${active}` }
                                    partiallyActive={ true }>
                                    Small Business
                                </Link>
                                <Link
                                    to="/insights"
                                    className={ `${ showSubheader ? `show-on-xl` : `show-on-xxl` } ${link}` }
                                    activeClassName={ `${active}` }
                                    partiallyActive={ true }>
                                    Insights
                                </Link>
                                <Link
                                to="/"
                                className={ `${headerCtaBtn} ${growOnHover}  btn btn-sm btn-animate-none ${isTransparentAtTop && isAtTop ? `btn-secondary-light` : `btn-secondary`}` }
                                id="header-trial-button">
                                Run payroll
                            </Link>
                            </div>
                        </div>
                        <div className={ rightWrapper }>
                            <button
                                type="button"
                                className={ `btn ${menuBtn}` }
                                onClick={ toggleMobileMenu }>
                                <span className="sr-only">Menu</span>
                                <div className={ `${menuIcon} ${isMenuOpen ? closeIcon : ``}` }/>
                            </button>
                        </div>
                    </div>
                </nav>
            </Headroom>
            <Menu isOpen={ isMenuOpen } toggleMenuFn={ toggleMobileMenu }/>
        </header>
    )
}

HeaderMain.propTypes = {
    siteTitle: PropTypes.string,
    pathname: PropTypes.string,
}

export default HeaderMain
